import moment from "moment";

export class MiniStandings {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "MiniStandings";
    this.scene = "Mini League Table";
    this.data = [];
    this.page = 1;
  }

  preview({ options }) {
    if (!options.page) {
      this.page = 1;
    }
    this.options = options;
    if (options.type === "TOP") {
      this.scene = "Mini League Table Top";
    } else if (options.type === "BOTTOM") {
      this.scene = "Mini League Table Bottom";
    }
    this.onAir = false;

    this.data = [];

    this.data.push({
      name: "Page",
      value: { text: this.page || "" },
    });
    this.data.push({
      name: "Title",
      // An explicit title wins, otherwise fall back to the group name (blank
      // for a league, which leaves the scene's own title in place).
      value: { text: options?.title || options?.standings?.group || "" },
    });
    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: options.game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + options.game?.competition?.badge || "" },
    });

    options.standings = JSON.parse(JSON.stringify(options?.standings));
    if (options.sort === "desc") {
      options.standings.teams = options?.standings?.teams?.reverse();
    }
    new Array(36)?.fill(1)?.map((_, index) => {
      let team = options?.standings?.teams?.[index];

      let row = index + 1;

      this.data.push({
        name: "Team Code " + row,
        value: { text: team?.team?.code || "" },
      });

      this.data.push({
        name: "Team Name " + row,
        value: { text: team?.team?.name || "" },
      });
      this.data.push({
        name: "Team Short Name " + row,
        value: { text: team?.team?.short_name ?? team?.team?.name ?? "" },
      });
      this.data.push({
        name: "Team Badge " + row,
        value: { image: "${user}" + team?.team?.variables?.badge || "" },
      });
      this.data.push({
        name: "Team Secondary Badge " + row,
        value: { image: "${user}" + team?.team?.variables?.alt_badge || "" },
      });
      this.data.push({
        name: "Team Video Badge " + row,
        value: { video: "${user}" + team?.team?.variables?.video_badge || "" },
      });
      this.data.push({
        name: "Team Rank " + row,
        value: { text: team?.rank ?? "" },
      });
      this.data.push({
        name: "Team Rank Status " + row,
        value: { text: team?.rank_status ?? "" },
      });
      this.data.push({
        name: "Team Achievement 1 Status " + row,
        value: { text: team?.achievment_status_1 ?? "" },
      });
      this.data.push({
        name: "Team Achievement 1 Type " + row,
        value: { text: team?.achievment_Type_1 ?? "" },
      });
      this.data.push({
        name: "Team Achievement 2 Status " + row,
        value: { text: team?.achievment_status_2 ?? "" },
      });
      this.data.push({
        name: "Team Achievement 2 Type " + row,
        value: { text: team?.achievment_Type_2 ?? "" },
      });
      this.data.push({
        name: "Team Achievement 3 Status " + row,
        value: { text: team?.achievment_status_3 ?? "" },
      });
      this.data.push({
        name: "Team Achievement 3 Type " + row,
        value: { text: team?.achievment_Type_3 ?? "" },
      });
      this.data.push({
        name: "Team Achievement 4 Status " + row,
        value: { text: team?.achievment_status_4 ?? "" },
      });
      this.data.push({
        name: "Team Achievement 4 Type " + row,
        value: { text: team?.achievment_Type_4 ?? "" },
      });
      this.data.push({
        name: "Team Achievement 5 Status " + row,
        value: { text: team?.achievment_status_5 ?? "" },
      });
      this.data.push({
        name: "Team Achievement 5 Type " + row,
        value: { text: team?.achievment_Type_5 ?? "" },
      });
      this.data.push({
        name: "Team Points " + row,
        value: { text: team?.points ?? "" },
      });
      this.data.push({
        name: "Team Games Played " + row,
        value: { text: team?.matches_played ?? "" },
      });
      this.data.push({
        name: "Team Games Won " + row,
        value: { text: team?.matches_won ?? "" },
      });
      this.data.push({
        name: "Team Games Lost " + row,
        value: { text: team?.matches_lost ?? "" },
      });
      this.data.push({
        name: "Team Games Drawn " + row,
        value: { text: team?.matches_drawn ?? "" },
      });
      this.data.push({
        name: "Team Goal Difference " + row,
        value: { text: team?.goal_difference ?? "" },
      });
      this.data.push({
        name: "Team Goals For " + row,
        value: { text: team?.goals_for ?? "" },
      });
      this.data.push({
        name: "Team Goals Against " + row,
        value: { text: team?.goals_against ?? "" },
      });
    });

    this.sendPreview(this.scene, 500, this.data, "IN");
  }
  animate({ options }) {
    this.page++;
    this.options.page = this.page;
    this.onAir = true;
    this.sendAnimate(this.scene, this.data);
    this.preview({ options: this.options });
  }
  animateOff({ options }) {
    this.page = 1;
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
